import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Utils } from 'src/modules/utils/shared/utils';
import { TreeIcon } from '../../models/tree-icon.model';

@Component({
    selector: 'tree-item-with-icons',
    templateUrl: './tree-item-with-icons.component.html',
    styleUrls: ['./tree-item-with-icons.component.scss'],
    standalone: false
})
export class TreeItemWithIconsComponent {

    _Utils = Utils;

    @Input()
    label = "";
    @Input()
    icons: TreeIcon[] = [];

    @Output()
    onClickIcon = new EventEmitter<TreeIcon>();

    click(icon: TreeIcon): void {
      if (icon.clickable && this.onClickIcon != null) {
        this.onClickIcon.emit(icon);
      }
    }
}
